import { render } from "./GreenPlacemat.svg?vue&type=template&id=786925eb"
const script = {}
script.render = render

export default script